export default __webpack_public_path__ + "static/Litepaper - German-0bd1b00d65de5b9f03326930adcd128a.pdf";